import { SiteClassification } from '../types/api';
import { getApi } from '.';
import { APIError } from '../lib/errors/api/APIError';

export const fetchSiteClassification = async (
  hostname: string
): Promise<SiteClassification | undefined> => {
  try {
    const { data }: { data: SiteClassification } =
      await getApi().sitesClassification.get({
        hostname,
      });

    return data;
  } catch (error) {
    if (typeof error === 'object' && (error as APIError).status === 404) {
      return undefined;
    }
    throw error;
  }
};
